import {
  Row,
  Col,
  Card,
  Badge,
  Spin,
} from "antd";
import React, { useState, useEffect } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import moment from "moment";
import { ArrowLeftIcon } from "lucide-react";

function View() {

  const sectionName   =   "Feedback";
  const routeName     =   "feedback";

  const location      =   useLocation();
  const params        =   useParams();
  const { request }   =   useRequest();

  const [list, setList]       = useState({});
  const [loading, setLoading] = useState(false);

  const fetchData = (id) => {
    setLoading(true);
    request({
      url: apiPath.viewFeedback + "/" + id,
      method: "GET",
      onSuccess: (data) => {
        setList(data.data);
        setLoading(false);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchData(params.id);
  }, [params.id]);

  return (
    <Row gutter={[16, 16]}>

      <Col xs={24} lg={12}>
        <Card title={`${sectionName} Details`}>
          <Spin spinning={loading} tip="Loading...">
            <div className="view-main-list">

              <div className="view-inner-cls">
                <h5>User Name:</h5>
                <h6 className="cap">{list?.user_id?.name || "-"}</h6>
              </div>

              <div className="view-inner-cls">
                <h5>User Email:</h5>
                <h6>{list?.user_id?.email || "-"}</h6>
              </div>

              <div className="view-inner-cls">
                <h5>Phone Number:</h5>
                <h6>{list?.phone || "-"}</h6>
              </div>

              <div className="view-inner-cls">
                <h5>Description:</h5>
                <h6 style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {list.description || "-"}
                </h6>
              </div>

              <div className="view-inner-cls">
                <h5>Created On:</h5>
                <h6>
                  {list.created_at
                    ? moment(list.created_at).format("DD-MMM-YYYY HH:mm")
                    : "-"}
                </h6>
              </div>

              <div className="float-right mt-3">
                <Link
                  className="ant-btn ant-btn-secondary"
                  to={`/${routeName}${location.search}`}
                >
                  <ArrowLeftIcon size={15} /> Back
                </Link>
              </div>
            </div>
          </Spin>
        </Card>
      </Col>

    </Row>
  );
}

export default View;
